import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import { Stepper } from "@shared/components/Stepper";
import { UsPaymentConnectionStep } from "./stepComponents/connection/connection";
import { ReviewStep } from "./stepComponents/review/review";
import { Button } from "@shared/ui/button";
import { ArrowLeft } from "lucide-react";
import { PageHeader } from "@shared/components/PageHeader";
import { useNavigate } from "react-router-dom";

export const CreateUsPaymentIntegration: React.FC = () => {
  const storageKey = "paymentus-integration-progress";
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (!id) {
      localStorage.removeItem(storageKey);
      if (window.location.hash) {
        window.location.hash = "";
      }
    }
  }, [id]);

  React.useEffect(() => {
    return () => {
      localStorage.removeItem(storageKey);
    };
  }, []);

  const steps = useMemo(
    () => [
      {
        title: "Connection",
        slug: "connection",
        description: "Credentials & verify",
        component: (
          <UsPaymentConnectionStep
            stepHelpers={undefined}
            currentStepIndex={0}
            onNext={() => {}}
            onPrevious={() => {}}
          />
        ),
        optional: false,
      },
      {
        title: "Review",
        slug: "review",
        description: "Activate integration",
        component: <ReviewStep />,
        optional: false,
      },
    ],
    [],
  );

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between pb-4">
        <div className="flex items-center gap-3">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => {
              localStorage.removeItem(storageKey);
              navigate("/integration-hub/payments");
            }}
          >
            <ArrowLeft size={16} />
          </Button>
          <PageHeader
            title="Connect US Payment"
            subtitle="Configure a new connector instance for synchronization, payment webhooks, and billing flows."
          />
        </div>
      </div>

      <Stepper
        steps={steps}
        onStepChange={() => {}}
        onStepSave={async () => {}}
        enableApiSave={false}
        saveOnStepChange={false}
        trackDirtyState={false}
        autoSave={true}
        persistProgress={true}
        allowSkip={false}
        storageKey={storageKey}
        enableRouting={true}
        onComplete={() => {}}
        onValidation={undefined}
        showDraftResume={true}
        allowStepClick={!!id}
        initialCompletedSteps={!!id ? [0, 1] : []}
      />
    </div>
  );
};

export default CreateUsPaymentIntegration;
